import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {BreadcrumbInterface, BreadcrumbsService} from "../../../../shared/services/breadcrumbs.service";
import {EducationModuleTitleInterface} from "../../../../shared/models/interfaces/education-module-title.interface";
import {BehaviorSubject, combineLatest, filter, Subject, takeUntil, tap} from "rxjs";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import {IomModuleService} from "../../../../shared/services/iom-module.service";
import { DeviceWidthService } from 'src/app/shared/services/width.service';
import { DeviceType } from 'src/app/shared/models/interfaces/device-type.type';
import { EduElementModuleTitleComponent } from '../../../../shared/components/edu-element-module-title/edu-element-module-title.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-oep-page',
    templateUrl: './oep-page.component.html',
    styleUrls: ['./oep-page.component.scss'],
    standalone: true,
    imports: [NgIf, EduElementModuleTitleComponent, RouterOutlet, AsyncPipe]
})

export class OepPageComponent implements OnInit, OnDestroy {

  firstLoading: boolean = true;
  breadcrumbs!: BreadcrumbInterface[];
  educationalModule!: EducationModuleTitleInterface;
  loaded$ = new BehaviorSubject<boolean>(false);
  isReloaded: boolean = false;
  isStep: boolean = false;
  deviceType: DeviceType = 'desktop';
  private destroy$ = new Subject<void>();

  get iomTotalScore(): number | undefined {
    return this.iom.totalScore;
  }

  constructor(
    private readonly breadcrumbsService: BreadcrumbsService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly iom: IomModuleService,
    private deviceWidth: DeviceWidthService,
    // private cdr: ChangeDetectorRef
  ) {}

    ngOnInit() {
      this.deviceWidth.getDeviceType$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(type => {
        this.deviceType = type;
      });
  
      this.loadData()
  
      this.router.events.pipe(
        takeUntil(this.destroy$),
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          this.firstLoading = false;
          this.loadData();
        })
      ).subscribe();
    }
  
    private loadData() {
      const routeSnapshot = this.route.firstChild?.snapshot;
      const stepId = routeSnapshot?.paramMap.get('stepId');
      const moduleId = routeSnapshot?.parent?.paramMap.get('moduleId');
  
      if (moduleId) {
        this.iom.checkTotalScore(moduleId);
      }
  
      this.isStep = stepId ? true : false;
  
      combineLatest([
        this.iom.getTitle$(moduleId || ''),
        this.breadcrumbsService.retrieveBreadcrumbs$(moduleId ||  '', stepId || '', routeSnapshot?.parent || undefined)
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([eduModule, breadcrumbs]) => {
        this.educationalModule = eduModule;
        this.breadcrumbs = breadcrumbs;
        this.isReloaded = true;
        this.loaded$.next(true);
        // this.cdr.detectChanges();
      });
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }